import styled from 'styled-components';

export const Status = styled.p`
  ${(props) => props.theme.config.typograph.default};
  color: ${(props) => props.theme.config.colors[props.color]};
  margin: ${(props) => props.theme.config.spacing.spacing_3} 0
    ${(props) => props.theme.config.spacing.spacing_5};
`;
